// src/components/GTM/PageTracker.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pageview',
      page: location.pathname + location.search,
      title: document.title
    });
  }, [location]);

  return null;
};

export default PageTracker;
